/**
 * user
 */
export default class User {
  constructor() {
    this.id = '';
    this.login = '';
    this.password = '';
    this.password_confirm = '';
    this.is_active = false;
    this.role = '';
    this.email = '';
    this.name = '';
  }
}
